import {usePost} from '../useHttpHooks';
import {EmptyResult, ProjectDataIndex} from '../types';

export type VibeCodeCommand = {
    prompt: string;
    historyPrompt: string;
    projectId: string;
    dataIndex: ProjectDataIndex;
    isEdit: boolean;
};

const useVibeCode = () =>
    usePost<VibeCodeCommand, EmptyResult>(`/api/assistant/vibe-coding`, {
        errorMessage: 'POST api/assistant/vibe-coding failed'
    });

export default useVibeCode;
